import { TableBody, TableCell, TableRow } from '@/components/ui/table';
import { AlertTriangle } from 'lucide-react';
import type { TableErrorViewProps } from '../types';
import { VisibleCenter } from './VisibleCenter';

export function TableErrorView({ error, columnCount }: TableErrorViewProps) {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={columnCount} className="px-4 py-6 text-destructive">
          <VisibleCenter className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4 shrink-0" />
            {error || 'An error occurred'}
          </VisibleCenter>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
